import { render, staticRenderFns } from "./LayerArc.vue?vue&type=template&id=f36424d0&"
import script from "./LayerArc.vue?vue&type=script&lang=js&"
export * from "./LayerArc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports